import React from "react";
import { levelLabel, metricDefinitions } from "./reportMetrics";

export default function MetricBars({ report }) {
  return (
    <div className="report-metrics">
      <div className="report-metrics__scale">
        <span>Below average</span>
        <span>Average</span>
        <span>Top</span>
      </div>
      {metricDefinitions(report.ml_model).map(({ key, label }, index) => (
        <div className="report-metric" key={key}>
          <span className="report-metric__label">
            <small>{index + 1}</small>
            {label}
          </span>
          <div
            className="report-metric__track"
            role="img"
            aria-label={`${label}: ${levelLabel(report[key])}`}
          >
            {report[key] != null && (
              <span
                style={{
                  width: `${(Math.max(0, Math.min(6, report[key])) / 6) * 100}%`,
                }}
              />
            )}
          </div>
          <strong>{levelLabel(report[key])}</strong>
        </div>
      ))}
      <p className="report-note">
        Model levels use the same seven categories as your original report.
        Predictions describe pedigree potential; they do not guarantee racing
        results.
      </p>
    </div>
  );
}
